export default{fontSize:"M",paddingX:"M",paddingY:"M",borderRadius:"S"};
